import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { useI18n } from "../i18n";

export const InstallButton = () => {
  const { t } = useI18n();
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone || localStorage.getItem("pwa_dismissed")) return;

    const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    if (isIOS) {
      setIosHint(true);
      setVisible(true);
      return;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem("pwa_dismissed", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="pwa-install" className="fixed bottom-4 right-4 z-[60] max-w-[calc(100vw-2rem)]">
      <div className="flex items-center gap-3 bg-[#0B1121] text-white rounded-2xl shadow-2xl border border-white/10 pl-4 pr-2 py-2">
        <span className="flex items-center justify-center h-9 w-9 rounded-full bg-white shrink-0">
          <img src="/prr-logo.png" alt="PRR" className="h-6 w-6 object-contain" />
        </span>
        {iosHint ? (
          <span className="text-xs leading-snug max-w-[220px]">{t("install.ios")}</span>
        ) : (
          <button onClick={install} data-testid="pwa-install-btn" className="flex items-center gap-2 text-sm font-semibold">
            <Download size={16} /> {t("install.btn")}
          </button>
        )}
        <button onClick={dismiss} data-testid="pwa-dismiss" className="ml-1 p-1.5 rounded-full hover:bg-white/10 shrink-0" aria-label={t("install.dismiss")}>
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
